import { ProductNameClient } from "../../../../../../../../Wrap/Api/Account/ProductName";
import { ProductOverviewClient } from "../../../../../../../../Wrap/Api/Account/ProductOverview";
import { AccountStatus } from "../../../../../../../../Wrap/Models/Domains/Account/SlAccounts/AccountStatus";

export class ProductOverviewProductInformationAction {
    public static getProductInformation(hierarchyId: string, callback) {
        const client = new ProductOverviewClient();
        const promise = client.get(hierarchyId);

        promise.onSuccess((data) => callback(data));

        promise.onError(() => {});
    }

    public static updateProductName(hierarchyid: string, name: string, callback) {
        const client = new ProductNameClient();
        const promise = client.put(hierarchyid, name);

        promise.onSuccess((data) => callback(data));

        promise.onError(() => {});
    }

    public static saveProductInformation(hierarchyId: string, name: string, accountStatus: AccountStatus, callback) {
        const client = new ProductOverviewClient();
        const promise = client.put(hierarchyId, name, accountStatus);

        promise.onSuccess((data) => callback(data));

        promise.onError(() => {});
    }
}
